import React from "react";
import "./serviceShowCase.css";
import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import { PROVIDER_URL } from "../../Service/AxiosConfig";

// ServiceShowcase.jsx
const ServiceShowcase = ({ data, className, onServiceClick }) => {
  const navigate = useNavigate();
  const { imgSrc, title, paragraph, buttonText, buttonText1, buttonText2 } = data;

  return (
    <div className={`service-showcase`}>
      <img src={imgSrc} alt={title} rel="preload" />
      <div className={`service-btn-wrapper ${className || ""}`}>
        <h2>{title}</h2>
        {paragraph && <p className="about-us-para">{paragraph}</p>}

        {buttonText1 && buttonText2 ? (
          <div className="btn-group">
            <button className="transparent-btn" onClick={() => navigate("/")}>
              {buttonText1}
            </button>
            <button
              className="transparent-btn"
              onClick={() => window.open( PROVIDER_URL, "_blank")}
            >
              {buttonText2}
            </button>
          </div>
        ) : (
          buttonText && (
            <button onClick={() => onServiceClick(title, data.id)}>
              {buttonText}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default ServiceShowcase;
